<template>
  <div class="v3-scene">
    <div class="v3-scene-2-3col" style="">

      <p class="v4-section-header-light color-storm" style="text-align: center; padding: 0 1em">
        Barton &amp; Gray is delighted to introduce our newest home in Chicago, Navy Pier. With brand new facilities and a prime location we are thrilled to add this destination to our portfolio.
        <br>
        <br>
        Join us for a kick-off event on <span>Saturday, June 21st!</span> Click the “Let's Party” tab above for more information.
      </p>

      <div class="chko-header v4-section-header-light color-fblue" style="margin: 1em auto;">Marina Maps</div>
      <div class="marina-maps-row">
        <img alt="Marina Map of Reid Murdoch Building marina" style="width: 360px; max-width: 100%;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/chicago-reid-murdoch.jpg">
        <img alt="Navy Pier Marina" style="width: 360px; max-width: 100%;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/chicago-navy-pier.jpg">
      </div>

      <div class="chko-header v4-section-header-light color-fblue" style="margin: 1em auto 0 auto;">Chicago From the Water</div>
      <div class="split-col-wrapper">
        <div class="split-col">
          <p class="v4-section-header-light color-storm">
            <span>Visit the Saltshed</span><br>
            Drop anchor next to the iconic waterfront venues “Fairgrounds” and enjoy a concert from the comfort of your own yacht.
          </p>

          <img alt="Saltshed concert in Chicago" style="width: 100%; max-width: 100%; margin: 0 auto;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/chko-saltshed.jpg">
          
          <p class="v4-section-header-light color-storm">
            <span>Waterfront Dining</span><br>
            Arrive to one of the many Chicago Waterfront restaurants in style whenever you like. Hop off your boat to enjoy a sit down meal or pick up take out to enjoy out on the water.
          </p>

          <img alt="Daychaser alongside a Chicago pier" style="width: 100%; margin: 0 auto;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/chko-pier.jpg">
        </div>
        <div class="split-col">
          <p class="v4-section-header-light color-storm">
            <span>Cruise the Chicago River</span><br>
            It's hard to sum up all that can be seen during a Hinckley ride through the Chicago River. From restaurants to famous architecture, the scenery is endless and with well managed city docks, hopping on and off when you feel inspired is easy. Also part of the famed “Great Loop” boaters have been twisting their way through the city by yacht for decades, and it's considered a must-do by any true yachtsman.
          </p>
          <img alt="Daychaser cruising the Chicago River" style="width: 100%;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/chko-chicago-river.jpg">
        </div>
      </div>
    </div>

    <div class="v3-scene-3col">
      <div class="schedule-holder bgcolor-gold">
        
        <div class="chko-header v4-section-header-light color-fblue" style="margin-top: 0.5em;">The Chicago Fleet</div>
        
        <div class="v4-section-header-light color-fblue" style="margin-top: 1em; margin-bottom: 1em; text-align: center;">Navy Pier</div>

        <!-- Chinap 48 -->
        <div class="v4-section-header-light color-storm" style="margin-top: 0.5em; text-align: center; font-size: 1.5em; font-weight: 600;">Chinap 48'</div>
        <div class="boat-profile">
          <img class="boat-profile" alt="Daychaser Chinap 48' 2d side profile" style="width: 320px;" src="http://cloud.bartonandgray.com/library/yachts/profiles/v3/cropped/daychaser-cropped.png">
        </div>

        <!-- Mariner II 40' -->
        <div class="v4-section-header-light color-storm" style="margin-top: 0.5em; text-align: center; font-size: 1.5em; font-weight: 600;">Mariner II 40'</div>
        <div class="boat-profile">
          <img class="boat-profile" alt="Talaria Mariner II 40' 2d side profile" style="width: 320px;" src="http://cloud.bartonandgray.com/library/yachts/profiles/v3/cropped/fleet-profiles_T44-01.png">
        </div>

        <hr>

        <div class="v4-section-header-light color-fblue" style="margin-top: 0.75em; margin-bottom: 0.8em; text-align: center;">Reid Murdoch<br>Center</div>

        <!-- Uncommon Molly 48'-->
        <div class="v4-section-header-light color-storm" style="margin-top: 0.5em; text-align: center; font-size: 1.5em; font-weight: 600;">Uncommon Molly 48'</div>
        <div class="boat-profile">
          <img class="boat-profile" alt="Daychaser Uncommon Molly 48' 2d side profile" style="width: 320px;" src="http://cloud.bartonandgray.com/library/yachts/profiles/v3/cropped/daychaser-cropped.png">
        </div>

        <!-- Eagle 40' -->
        <div class="v4-section-header-light color-storm" style="margin-top: 0.5em; text-align: center; font-size: 1.5em; font-weight: 600;">Eagle 40'</div>
        <div class="boat-profile" style="margin-bottom: 2em;">
          <img class="boat-profile" alt="Talaria Eagle 40' 2d side profile" style="width: 320px;" src="http://cloud.bartonandgray.com/library/yachts/profiles/v3/cropped/fleet-profiles_T44-01.png">
        </div>

        <!-- Almost Heaven 36' -->
        <div class="v4-section-header-light color-storm" style="margin-top: 0.5em; text-align: center; font-size: 1.5em; font-weight: 600;">Almost Heaven 36'</div>
        <div class="boat-profile">
          <img class="" alt="Talaria Almost Heaven 36' 2d side profile" style="width: 320px;" src="http://cloud.bartonandgray.com/library/yachts/profiles/v3/cropped/fleet-profiles_36-Classic-01.png">
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped lang="scss">

.v3-scene{
  @media only screen and (max-width: 1280px){
    gap: 2em;
  }
}

.v3-scene-3col{
  @media only screen and (max-width: 1280px){
    padding: 0 1em;
  }
}

.v3-scene-2-3col{
  @media only screen and (min-width: 1280px){
    padding-right: 2em;
  }
}

.v3-scene-3col, .v3-scene-2-3col{
  @media only screen and (max-width: 1280px){
    width: 480px !important;
  }
}

p{
  font-size: 1.875em;
  line-height: 125%;
}

span{
  font-weight: 600;
}

.marina-maps-row{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  @media only screen and (max-width: 1280px){
    flex-direction: column;
    align-items: center;
    gap: 2em;
  }
}

.chko-header{
  font-weight: 600;
  text-align: center;
}

.split-col-wrapper{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .split-col{
    width: 47%;
  }
  @media only screen and (max-width: 1280px){
    flex-direction: column;
    justify-content: flex-start;
    padding: 0 1em;
    .split-col{
      width: 100%;
    }
  }
}

img{
  max-width: 100%;
}

.boat-profile{
  margin: 0 auto;
  text-align: center;
}

</style>